export default __webpack_public_path__ + "static/media/default-amenity.97769cad.svg";